import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em']

export function sanitizeHtml(html: string | undefined | null): string {
  if (!html) return ''
  if (typeof window === 'undefined') return html // SSR: backend already sanitized
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR: [] })
}
